// @ts-nocheck
import { populate } from 'populate';
import type { Container } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'b4e66c93-4803-4477-9dac-8b8fe89d74e1',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'Rectangle',
        x: -180,
        y: -115,
        width: 360,
        height: 250
      },
      parent: ''
    },
    {
      id: 'e9279438-af99-47ca-8bd3-ca07354249d5',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 9,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Item_Blue_Background_Variation',
      parent: 'b4e66c93-4803-4477-9dac-8b8fe89d74e1',
      data: {
        DEBUG: true
      }
    },
    {
      id: '0c189aa5-1907-4335-b831-97e806e42516',
      type: 'Container',
      name: 'buttonWrapper',
      className: '',
      x: 0,
      y: 86,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'b4e66c93-4803-4477-9dac-8b8fe89d74e1'
    },
    {
      id: '0c733a6c-95a3-42fc-8423-60698469329a',
      type: 'Container',
      name: 'button',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '0c189aa5-1907-4335-b831-97e806e42516'
    },
    {
      id: '0362c9eb-59fc-4640-a148-2dc5ab9181dc',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 4,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Small_Button_Claim',
      parent: '0c733a6c-95a3-42fc-8423-60698469329a'
    },
    {
      id: 'be8f55a7-1af0-4e04-99e3-61193764a6de',
      type: 'Text',
      name: '',
      className: '',
      x: 0,
      y: -1,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Claim',
      localize: true,
      maxWidth: 132,
      maxHeight: 79,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#00632d',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.57,
        dropShadowBlur: 0,
        dropShadowColor: '#00632d',
        dropShadowDistance: 2,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '0c733a6c-95a3-42fc-8423-60698469329a'
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '3.1.0',
  animations: [
    {
      id: 'bc89a327-0fd1-4aea-b7af-a2d3dfde5d4f',
      name: 'disappear',
      playingSpeed: 1,
      totalDuration: 300,
      blocks: [
        {
          id: '6374ab93-258c-4963-9084-31e476e03298',
          type: 'Tween',
          name: 'New_tween',
          duration: 300,
          track: 1,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'button',
          easing: 'CubicIn',
          disabled: false
        }
      ]
    },
    {
      id: 'b6ae5d0a-2b04-4cfb-9c1b-2790ba80e9b7',
      name: 'appear',
      playingSpeed: 1,
      totalDuration: 300,
      blocks: [
        {
          id: '5c213d80-c42f-4b85-92da-e09e862b5d95',
          type: 'Setter',
          name: 'New_setter',
          track: 1,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'button',
          disabled: false
        },
        {
          id: 'f22bfb4f-d424-475f-991e-73e3a303e621',
          type: 'Tween',
          name: 'New_tween_1',
          duration: 300,
          track: 2,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 0,
          sourceName: 'button',
          easing: 'ElasticOut',
          disabled: false
        }
      ]
    },
    {
      id: 'c2947075-06fd-4526-82c6-bef99aad40ce',
      name: 'Idle',
      playingSpeed: 1,
      totalDuration: 1500,
      blocks: [
        {
          id: '70613fc2-8608-490d-9e0b-9c5992a94c58',
          type: 'Tween',
          name: 'New_tween_2',
          duration: 200,
          track: 2,
          target: {
            scale: {
              x: 1.05,
              y: 1.05
            }
          },
          startAt: 0,
          sourceName: 'buttonWrapper',
          easing: 'SinusoidalInOut',
          disabled: false
        },
        {
          id: '6399a277-1fff-48c1-a9fb-7fdc12a37047',
          type: 'Tween',
          name: 'New_tween_2_copy',
          duration: 200,
          track: 2,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 200,
          sourceName: 'buttonWrapper',
          easing: 'SinusoidalInOut',
          disabled: false
        },
        {
          id: '8001cbab-024e-4d13-b0af-4b80f1a6137b',
          type: 'Tween',
          name: 'New_tween_2_copy_1',
          duration: 200,
          track: 2,
          target: {
            scale: {
              x: 1.05,
              y: 1.05
            }
          },
          startAt: 400,
          sourceName: 'buttonWrapper',
          easing: 'SinusoidalInOut',
          disabled: false
        },
        {
          id: 'a2a1e87a-4662-491e-8171-bcd4deeffed0',
          type: 'Tween',
          name: 'New_tween_2_copy_copy',
          duration: 200,
          track: 2,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 600,
          sourceName: 'buttonWrapper',
          easing: 'SinusoidalInOut',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class SeasonPassRewardClaimButtonLayout {
  static raw = raw;
  root!: Container;
  buttonWrapper!: Container;
  button!: Container;
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}

export abstract class disappear {
  Layout: {
    button: object;
  };

  BlockTypeByName: {
    New_tween: object;
  };

  flowData = raw.animations[0];
}

export abstract class appear {
  Layout: {
    button: object;
  };

  BlockTypeByName: {
    New_setter: object;
    New_tween_1: object;
  };

  flowData = raw.animations[1];
}

export abstract class Idle {
  Layout: {
    buttonWrapper: object;
  };

  BlockTypeByName: {
    New_tween_2: object;
    New_tween_2_copy: object;
    New_tween_2_copy_1: object;
    New_tween_2_copy_copy: object;
  };

  flowData = raw.animations[2];
}
